import TabOptions from '../options';

export class Model {
  studyGoal = null;
  generalObservations = null;
  secondDate = null;
  otherInterventions = null;
}
export class Tab {
  id = 'ThreeToFour';
  title = 'III-IV';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      studyGoal: model.studyGoal,
      generalObservations: model.generalObservations,
      threeToFourOptions: model.options.filter((x) => x.checked),
    };
  };
}
export default new Tab();
